<section class="main-div p-4">
  <div class="tab-box align-items-center w-100">
    <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-4"
      (click)="onSemiTabChange('clock_request')" [ngClass]="currentSemiTab == 'clock_request' ? 'active-tab' : ''">
      <div class="tab-txt ps-1 ps-sm-2">Clock request</div>
    </div>
    <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2 me-auto" id="i-1"
      [ngClass]="currentSemiTab == 'not_clocked_tab' ? 'active-tab' : ''" (click)="onSemiTabChange('not_clocked_tab')">
      <div class="tab-txt ps-1 ps-sm-2">Not Clocked</div>
    </div>
  </div>

  <div>
    <div [hidden]="currentSemiTab != 'clock_request'">

      <div class="search-cont gap-sm-3 mt-3">
        <div class="s-in form-input me-0" style="position:relative">
          <mat-icon class="input-icon">search</mat-icon>
          <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="objData.clock_request.sh"
            (input)="onSearch($event,'clock_request')" (keyup.enter)="onGo('clock_request')" />
        </div>
      </div>
      <div class="clock-content table-container table-container-n mt-3">
        <table mat-table [dataSource]="dataSourceToday" class="mat-elevation-z8 demo-table">
          <ng-container matColumnDef="time">
            <th mat-header-cell *matHeaderCellDef>Start - End Time</th>
            <td mat-cell *matCellDef="let element">
              <div (click)="onEditClockTime(element)">
                {{ element.st_ti }} {{ element.ed_ti }}
                <i class="material-icons cursor-pointer">mode_edit</i>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="break_time">
            <th mat-header-cell *matHeaderCellDef>Break Time</th>
            <td mat-cell *matCellDef="let element">
              <div (click)="onEditBreakTime(element)">{{element.br_tii }} {{element.br_tio }}
                <i class="material-icons cursor-pointer">mode_edit</i>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Candidate Name </th>
            <td mat-cell *matCellDef="let element">
              <div class="user-profile" (click)="openTimeSheetDetailsModel(element)">
                <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"> </div>
                <div class="">
                  <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                  <div class="sub-head">{{element.email}}</div>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef>Category</th>
            <td mat-cell *matCellDef="let element">
              <div class="u-box flex-column">
                <div class="name">{{element.j_c}}</div>
                <div class="email">{{element.j_sc}}</div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef>Location</th>
            <td mat-cell *matCellDef="let element"> hello</td>
          </ng-container>
          <ng-container matColumnDef="clock-in">
            <th mat-header-cell *matHeaderCellDef>Clock In</th>
            <td mat-cell *matCellDef="let element">
              <a target="blank" *ngIf="element.lat" [href]="googleMapLink + element.lat + ',' + element.long">
                <i class="material-icons"
                  [ngClass]="element.in_icon == 1 ? 'color-red' : 'color-green' ">location_on</i>
              </a>
              <div class="text-bold" *ngIf="!element.lat">
                <span>--</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="clock-out">
            <th mat-header-cell *matHeaderCellDef>Clock out</th>
            <td mat-cell *matCellDef="let element">
              <a target="blank" *ngIf="element.c_long" [href]="googleMapLink + element.c_lat + ',' + element.c_long">
                <i class="material-icons"
                  [ngClass]="element.out_icon == 1 ? 'color-red' : 'color-green' ">location_on</i>
              </a>
              <div class="text-bold" *ngIf="!element.c_long">
                <span>--</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="total-hours">
            <th mat-header-cell *matHeaderCellDef>Total hours</th>
            <td mat-cell *matCellDef="let element"> {{element.wo_ti}}</td>
          </ng-container>
          <ng-container ntainer matColumnDef="scheduled-hours">
            <th mat-header-cell *matHeaderCellDef>Scheduled hours</th>
            <td mat-cell *matCellDef="let element"> hello</td>
          </ng-container>
          <ng-container matColumnDef="overtime">
            <th mat-header-cell *matHeaderCellDef>OverTime</th>
            <td mat-cell *matCellDef="let element">
              {{element.ov_ti_duration}}
              <div class="text-bold" *ngIf="!element.ov_ti_duration">
                <span>--</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <div class="text-bold st-box  d-flex ">
                <span class="active badge-c d-box" *ngIf="element.app==1">{{"Accepted"|translate}}</span>
                <span class="pending badge-c d-box" *ngIf="element.app==2">{{"Pending"|translate}}</span>
                <span class="un-attend   badge-c d-box" *ngIf="element.app==0">{{"Rejected"|translate}}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="overtime_status">
            <th mat-header-cell *matHeaderCellDef>OverTime Status</th>
            <td mat-cell *matCellDef="let element">
              <div class="text-bold st-box  d-flex ">
                <span class="active badge-c d-box" *ngIf="element.ov_ti==1">{{"Accepted"|translate}}</span>
                <span class="pending badge-c d-box" *ngIf="element.ov_ti==2">{{"Pending"|translate}}</span>
                <span class="un-attend   badge-c d-box" *ngIf="element.ov_ti==0">{{"Rejected"|translate}}</span>
                <span *ngIf="element.ov_ti==3">--</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="accept-reject">
            <th mat-header-cell *matHeaderCellDef>Accept/reject</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex">
                <div class="status-box accept me-2" matTooltip="{{'BUTTON.ACCEPT' | translate}}"
                  [ngClass]="{'opacity':element.app=='1'}" (click)="confirmationAlert(element,'status','yes')">
                  <img src="assets/images/icons/tick_correct.svg" class="img-fluid" alt="">
                </div>
                <div class="status-box reject " matTooltip="{{'BUTTON.REJECT' | translate}}"
                  [ngClass]="{'opacity':element.app=='0'}" (click)="confirmationAlert(element,'status','no')">
                  <img src="assets/images/icons/cancel.svg" class="img-fluid" alt="">
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="overtime_accept_reject">
            <th mat-header-cell *matHeaderCellDef>Overtime Accept/reject</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex" *ngIf="element.ov_ti!=3">
                <div class="status-box accept me-2" matTooltip="{{'BUTTON.ACCEPT' | translate}}"
                  [ngClass]="{'opacity':element.ov_ti=='1'}" (click)="confirmationAlert(element,'overtime','yes')">
                  <img src="assets/images/icons/tick_correct.svg" class="img-fluid" alt="">
                </div>
                <div class="status-box reject" matTooltip="{{'BUTTON.REJECT' | translate}}"
                  [ngClass]="{'opacity':element.ov_ti=='0'}" (click)="confirmationAlert(element,'overtime','no')">
                  <img src="assets/images/icons/cancel.svg" class="img-fluid" alt="">
                </div>
              </div>
              <div class="text-bold" *ngIf="element.ov_ti==3">
                <span>--</span>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsF"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsF;"></tr>
        </table>
        <div class="mat-table__message" *ngIf="dataSourceToday.data.length==0">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>
      <div class="pagination-cont" *ngIf="dataSourceToday.data.length!=0">
        <div class="show-item">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event,'clock_request')"
            [(ngModel)]="objData.clock_request.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="page-c">
          <ngb-pagination [collectionSize]="objData.clock_request.count" [(page)]="objData.clock_request.currentPage"
            [pageSize]="objData.clock_request.itemsPerPage" [maxSize]="objData.clock_request.maxPaginationSize"
            (pageChange)="onPageChange($event,'clock_request')"></ngb-pagination>
        </div>
      </div>

    </div>
    <div [hidden]="currentSemiTab != 'not_clocked_tab'">
      <div>
        <app-filter *ngIf="objData.not_clocked_tab.isFilterShow" (childEvent)="callApi($event,'not_clocked_tab')"
          [fieldCol]="filterArr"></app-filter>
      </div>
      <div class="search-cont gap-sm-3 mt-3">
        <div class="s-in form-input me-0" style="position:relative">
          <mat-icon class="input-icon">search</mat-icon>
          <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="objData.not_clocked_tab.sh"
            (input)="onSearch($event,'not_clocked_tab')" (keyup.enter)="onGo('not_clocked_tab')" />
        </div>
      </div>
      <div class="clock-content table-container table-container-n mt-3">
        <table mat-table [dataSource]="dataSourceNotclockedIn" class="mat-elevation-z8 demo-table">
          <!-- Position Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Candidate Name </th>
            <td mat-cell *matCellDef="let element">
              <div class="user-profile">
                <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"> </div>
                <div class="">
                  <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                  <div class="sub-head">{{element.email}}</div>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef>Category</th>
            <td mat-cell *matCellDef="let element">
              <div class="main-head">{{element.j_c}} </div>
              <div class="sub-head">{{element.j_sc}}</div>
            </td>
          </ng-container>


          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let element">{{element.st_dt}}</td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>Address</th>
            <td mat-cell *matCellDef="let element">{{element.add}}</td>
          </ng-container>
          <ng-container matColumnDef="shift-time">
            <th mat-header-cell *matHeaderCellDef>Shift Time</th>
            <td mat-cell *matCellDef="let element">{{element.c_st_ti}}-{{element.c_ed_ti}}</td>
          </ng-container>
          <ng-container matColumnDef="phone-number">
            <th mat-header-cell *matHeaderCellDef>Phone number</th>
            <td mat-cell *matCellDef="let element">{{element.phone_number}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element" (click)="onAddTimeForSpecificJob(element)"> <i
                class="material-icons more-ic">more_vert</i></td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsC"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsC;"></tr>
        </table>
        <div class="mat-table__message" *ngIf="dataSourceNotclockedIn.data.length==0">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>
      <div class="pagination-cont" *ngIf="dataSourceNotclockedIn.data.length!=0">
        <div class="show-item">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event,'not_clocked_tab')"
            [(ngModel)]="objData.not_clocked_tab.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="page-c">
          <ngb-pagination [collectionSize]="objData.not_clocked_tab.count"
            [(page)]="objData.not_clocked_tab.currentPage" [pageSize]="objData.not_clocked_tab.itemsPerPage"
            [maxSize]="objData.not_clocked_tab.maxPaginationSize"
            (pageChange)="onPageChange($event,'not_clocked_tab')"></ngb-pagination>
        </div>
      </div>

      <div class="mat-table__message" *ngIf="ifnot == true">
        <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
      </div>
    </div>
  </div>
</section>